import React, { memo } from 'react'

import { number, string, bool } from 'prop-types'

import NavbarIcon from 'Pods/UnifiedNavigation/Shared/NavbarIcon/NavbarIcon'

const ACTION_LABELS = {
  'cart-action': 'Cart',
  'inbox-action': 'Messages',
  'notifications-action': 'Notifications',
}
const ICON_SIZE = { width: '20', height: '20' }

// A single header action (cart / inbox / notifications). Each renders as a button
// trigger that opens its popover (cart / inbox / notifications); the popovers are
// built in a later phase.
function UserAction({ id, icon, isForUser = false, isCurrentUser = false, count = 0 }) {
  if (isForUser && !isCurrentUser) {
    return null
  }

  const hasBadge = count > 0

  return (
    <li className="unified-nav__action">
      <button
        type="button"
        className="unified-nav__action-link"
        aria-label={ACTION_LABELS[id]}
        aria-haspopup="true"
      >
        <NavbarIcon type={icon} size={ICON_SIZE} className="unified-nav__action-icon" />
        {hasBadge && (
          <span className="unified-nav__action-badge">{count}</span>
        )}
      </button>
    </li>
  )
}

UserAction.propTypes = {
  id: string.isRequired,
  icon: string.isRequired,
  isForUser: bool,
  isCurrentUser: bool,
  count: number,
}

export default memo(UserAction)
